module.exports = __webpack_public_path__ + "static/media/banner.043c1db5.png";